module.exports = __webpack_public_path__ + "static/media/Articles.c115d704.png";